import { render, staticRenderFns } from "./anApprovad.vue?vue&type=template&id=754ff455"
import script from "./anApprovad.vue?vue&type=script&lang=js"
export * from "./anApprovad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports